// ----------------------------------------------------------------------

import { pxToRem } from '../../utils/fontSizeTransform';

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          'fontWeight': 400,
          'borderRadius': '8px',
          '&:hover': {
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          fontSize: pxToRem(16),
          lineHeight: '24px',
          padding: theme.spacing(1, 2),
          height: 44
        },
        containedPrimary: {
          'boxShadow': 'none',
          'color': theme.palette.common.white,
          '&:hover': {
            backgroundColor: theme.palette.primary.main
          },
          '&:active': {
            backgroundColor: theme.palette.primary.light
          }
        },
        textPrimary: {
          'boxShadow': 'none',
          'color': theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.light
          },
          '&:active': {
            backgroundColor: theme.palette.primary.light
          },
          'backgroundColor': theme.palette.primary.light
        },
        containedInherit: {
          'boxShadow': 'none',
          'backgroundColor': '#F0F5FF',
          'color': '#0050C8',
          '&:hover': {
            backgroundColor: theme.palette.primary.light
          },
          '&:active': {
            backgroundColor: '#F0F5FF'
          }
        },
        outlinedInherit: {
          'border': `none`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          },
          'background': theme.palette.primary.light
        },
        outlined: {
          'background': 'white !important',
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          },
          'background': theme.palette.primary.light
        },
        disabled: {
          background: theme.palette.grey.disabled,
          color: '#A7A9BC'
        }
      }
    }
  };
}
